// extracted by mini-css-extract-plugin
export var completionBody = "_k5-2";
export var completionCard = "_k5-0";
export var completionFooter = "_k5-3";
export var completionTitle = "_k5-1";